import type { AreaCode } from '@ebalance/proto/bfftypes/v1/area_pb'
import type {
  BiddingBlockApprovalRequest,
  BiddingBlockBid,
} from '@ebalance/proto/bffuser/v1/bidding_block_model_pb'

/** group の leg (札)。 proto は primary を常在、 secondary を LINK / LOOP のみ持つ。 */
export const blockGroupLegs = (
  group: BiddingBlockApprovalRequest,
): BiddingBlockBid[] =>
  [group.primary, group.secondary].filter(
    (leg): leg is BiddingBlockBid => leg !== undefined,
  )

/**
 * group の leg (札) 数。 proto は primary を常在、 secondary を LINK / LOOP のみ持つ
 * (AC-BSP-059: グループ内の各レグは同じ承認状態を投影する)。
 *
 * 確認 modal の件数行で「グループ 1 件 (N 札)」 と単位を明示するために使う (= 申請取消 /
 * 承認の双方。 「札件数 1 件」 では LINK / LOOP の対象を誤認する)。 対象が解決できない
 * (undefined、 背景 refetch 中など) 間は 1 に倒す (= 表示のみの縮退。 確定時は各 handler が
 * 再解決して fail-closed で弾く)。
 */
export const countBlockGroupLegs = (
  group: BiddingBlockApprovalRequest | undefined,
): number => (group?.secondary !== undefined ? 2 : 1)

/**
 * ブロック入札一覧のエリアの絞り込みで残す leg。 LINK / LOOP は 2 本の leg で 1 組なので、
 * どちらかの leg が選んだエリアに合えば、 組の全 leg を残す (片方の leg だけを表示しない。
 * design `spot.html` のブロック一覧と同じ規則)。 `rows` の並びのまま返す。
 */
export const filterBlockRowsByAreas = <
  R extends { groupId: string; areaCode: AreaCode },
>(
  rows: readonly R[],
  areas: ReadonlySet<AreaCode>,
): R[] => {
  const groupIds = new Set(
    rows.filter((r) => areas.has(r.areaCode)).map((r) => r.groupId),
  )
  return rows.filter((r) => groupIds.has(r.groupId))
}
